module.exports = __webpack_public_path__ + "static/project-management@2x.e6dd28dc.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/guides/img/project-management@2x.png
// module id = 817
// module chunks = 35783957827783